module.exports = __webpack_public_path__ + "static/media/logo.7de0edc4.png";